import SURGERY_CONTEXT_ELEMENT from 'shared/ramq/requiredDetails/surgeryContextElement';
import { RAMQContextElements } from 'shared/ramq/RamqContextElements';
import { DeletableValueOnUnmountSingleSelectCheckboxGroup } from 'app/components/Form/Fields';

interface ListValue {
  label: string;
  value: string;
}

const getList = (date: number) => {
  const ramqContextElement1948 = RAMQContextElements.get('1948', date);
  const ramqContextElement1949 = RAMQContextElements.get('1949', date);
  const list: ListValue[] = [];

  if (ramqContextElement1948) {
    list.push({ label: 'Chirurgie élective >1 an', value: ramqContextElement1948.code });
  }
  if (ramqContextElement1949) {
    list.push({ label: 'Chirurgie oncologique >56 jours', value: ramqContextElement1949.code });
  }

  return list;
};

const getAssociatedFields = (date: number) => {
  const ramqContextElement1948 = RAMQContextElements.get('1948', date);
  const ramqContextElement1949 = RAMQContextElements.get('1949', date);
  if (!ramqContextElement1948 && !ramqContextElement1949) {
    return [];
  }

  return [
    {
      label: 'En attente de chirurgie',
      getName: (index) => `codes[${index}].${SURGERY_CONTEXT_ELEMENT}`,
      type: DeletableValueOnUnmountSingleSelectCheckboxGroup,
      list: getList(date),
      notRequired: true
    }
  ];
};

export default { getAssociatedFields };
